module.exports = __webpack_public_path__ + "img/green_041.659a72ca.png";